import React, { useRef, useEffect, useState } from 'react';
import { getDeviceType } from 'js/utils/deviceDetection';

const ScaleContainer = ({
  children,
  width = '768',
  height = '1024',
  vPosition = 'top',
  hPosition = 'left',
  offset = 0,
  minScale = 0,
  maxScale = 1,
  forceResize = false,
  addScaleId = false,
}) => {
  const scalableContainer = useRef();
  const uiContainer = useRef();

  const [scale, updateScale] = useState(1);

  useEffect(() => {
    if (forceResize) {
      resizeFunc();
    }
  }, [forceResize]);

  useEffect(() => {
    resizeFunc();

    window.addEventListener('resize', resizeFunc);
    return () => {
      window.removeEventListener('resize', resizeFunc);
    };
  }, []);

  const resizeFunc = () => {
    if (uiContainer.current && scalableContainer.current) {
      const widthUi = uiContainer.current.clientWidth;
      const heightUi = uiContainer.current.clientHeight;

      const width = scalableContainer.current.clientWidth;
      const height = scalableContainer.current.clientHeight;

      const scaleFactor = Math.min(height / heightUi, width / widthUi);

      if (getDeviceType() !== 'desktop') {
        const scaleFactorMin = Math.max(minScale, Math.min(scaleFactor, maxScale));

        updateScale(scaleFactorMin);
        return;
      }

      const scale = Math.min(scaleFactor, maxScale);

      updateScale(isNaN(scale) ? minScale : scale);
    }
  };

  const origin = { transformOrigin: `${hPosition} ${vPosition}` };
  const hPos =
    hPosition === 'left'
      ? { left: 0 }
      : hPosition === 'center'
      ? { left: '50%', transform: `translateX(-50%) scale(${scale})` }
      : { right: 0 };
  const vPos =
    vPosition === 'top'
      ? { top: offset + 'px' }
      : vPosition === 'center'
      ? { top: '50%', transform: `translateY(-50%) scale(${scale})` }
      : { bottom: offset + 'px' };

  if (hPosition === 'center' && vPosition === 'center') {
    origin.transformOrigin = `center center`;
    hPos.transform = `translate(-50%, -50%) scale(${scale})`;
    vPos.top = '50%';
    delete vPos.transform;
  }

  return (
    <div
      className="scale-container"
      ref={scalableContainer}
      style={{ height: '100dvh', width: '100%', position: 'relative', zIndex: 1 }}
    >
      <div
        ref={uiContainer}
        id={addScaleId ? 'scale-container-ui' : ''}
        style={{
          width: '100%',
          minWidth: typeof width === 'string' && width.includes('%') ? width : `${width}px`,
          height: '100%',
          minHeight:
            typeof height === 'string' && (height.includes('%') || height.includes('vh')) ? height : `${height}px`,
          transform: `scale(${scale})`,
          position: 'absolute',
          ...hPos,
          ...vPos,
          ...origin,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default ScaleContainer;
